import './App.css';
import EmailDashboard from './EmailDashboard';

function App() {
  return (
    <div className="App">
      <EmailDashboard/>
    </div>
  );
}

export default App;
